<div class="cx-login-section">
  <div class="cx-login-section__banner">
    <cx-abstract [component]="components | cmsComponent: CX_COMPONENT.BANNER_GRID" />
  </div>

  <div class="cx-login-section__form">
    <div class="cx-login-section__form--header">
      <cx-abstract [component]="components | cmsComponent: CX_COMPONENT.LOGO" />
      <p class="cx-login-section__form--description">{{ 'login.description' | translate }}</p>
    </div>

    <form autocomplete="off" [formGroup]="form" (submit)="submit()">
      <div class="cx-login-section__form--fields">
        <cx-input-field
          id="user"
          type="text"
          label="{{ 'register.name.label' | translate }}"
          formControlName="user"
          [invalid]="!!(invalidGrant$ | async)"
        />
        <cx-input-field
          id="password"
          type="password"
          label="{{ 'register.password.label' | translate }}"
          formControlName="password"
          [isPassword]="true"
          [invalid]="!!(invalidGrant$ | async)"
        />

        <button type="button" class="cx-login-section__form--forgot-password" (click)="openForgotPassword()">
          {{ 'login.forgotPassword' | translate }}
        </button>

        <span *ngIf="invalidGrant$ | async" class="error-message">
          {{ errorMessage }}
        </span>
      </div>

      <cx-button type="submit" class="w-100" [disabled]="form.invalid || !!(isLoading$ | async)">
        @if (isLoading$ | async) {
          <local-loader></local-loader>
        } @else {
          {{ 'login.submitButton' | translate }}
        }
      </cx-button>
    </form>
  </div>
</div>
